import { Component } from "@angular/core";
import { CustomizerSettingsService } from "src/app/core/services/customizer-settings.service";

@Component({
  selector: "app-footer",
  imports: [],
  standalone: true,
  templateUrl: "./footer.component.html",
  styleUrl: "./footer.component.scss",
})
export class FooterComponent {
  constructor(public themeService: CustomizerSettingsService) {}
}
